const messages = {
    Register: {
        message: 'Organize your transactions'
    },
    hello: 'JAMURCO INGLES HELLO'

}
export default messages;